import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MaterialGrid from '@material-ui/core/Grid';
import LoadingProgress from 'common/components/progress/loading';
import _ from 'lodash';
import AlertDialogSlide from 'common/components/dialog/dialogActivits';
import Informations from 'modules/owner/pages/actions/sections/information';
import ActionsTabs from 'common/components/navigation/actionsTab/activityTabs';
import PrimaryButton from 'common/components/buttons/primaryButton';
import placeholder_illustration from 'assets/img/placeholder_illustration.png';
import Prize from 'modules/owner/pages/actions/sections/prize';
import Publish from 'modules/owner/pages/actions/sections/publish';
import { getFormValues } from 'redux-form';
import { imgToBase64, imgToImgType } from 'helpers/utils';
import { publishAction } from 'modules/owner/pages/actions/activeActions/activeActionsScripts';
import { isMobile } from 'react-device-detect';
import { getList as getLottiesList } from '../../lotties/lottiesActions';
import {
  submitAction,
  getDetail,
  dispatchFormReset,
  savePartialy,
} from './subscribeProductActions';
import Interaction from './sections/interaction';

function Main(props) {
  const [value, setValue] = React.useState(0);
  const [form, setForm] = React.useState(props.formValues);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  useEffect(() => {
    props.getLottiesList();
  }, []);

  useEffect(() => {
    if (props.formValues) {
      setForm(props.formValues);
    }
  }, [props.formValues]);

  async function handleChange(values, router) {
    values.base64 = values.image.base64;
    if (!_.isUndefined(values.image.base64)) {
      values.imageType = imgToImgType(values.image);
    }

    values.type_action = 21;

    values.body = {
      ...values,
      name: values.body_name,
      description: values.body_description,
    };
    delete values.body.image;
    delete values.body.base64;
    delete values.body.imageType;
    values.body = JSON.stringify(values.body);

    if (values.newPrice === 0 || values.newPrice === '0') {
      values.allowance = 0;
    }
    props.savePartialy(values, router, setValue, value);
  }

  function goBack() {
    setValue(value - 1);
  }
  function handleOpenConfirmation() {
    setOpenConfirmation(true);
  }
  function handleCancelClose() {
    setOpenConfirmation(false);
  }

  function handleNativeChange(e, newValue) {
    if (
      props.router.params.action === 'editar' ||
      props.router.params.action === 'proposta' ||
      props.router.params.action === 'rascunho'
    ) {
      setValue(newValue);
    } else {
      if (newValue < value) {
        setValue(newValue);
      }
    }
  }

  useEffect(() => {
    if (
      props.router.params.action === 'editar' ||
      props.router.params.action === 'proposta' ||
      props.router.params.action === 'rascunho'
    ) {
      props.getDetail(props.router.params.id);
    }
  }, []);

  const onSubmit = async (values) => {
    if (!_.isUndefined(values.image.base64)) {
      values.imageType = imgToImgType(values.image);
      values.base64 = imgToBase64(values.image);
    }

    values.station = props.auth.user.establishments[0].stations[0].id;
    values.type_action = 21;

    if (props.router.params.action === 'proposta') {
      values.sponsored = true;
      values.partner = values.partner_id;
    }

    const target =
      values.segmentation_type === 'public'
        ? {
            age: {
              from: values.from,
              to: values.to,
            },
            states: values.states,
            associated: values.associated,
            internal: values.internal,
            plans: values.segment_plans,
            entities: values.entities,
          }
        : {
            segment_users: values.segment_users,
          };

    values.target = target;
    const create_or_update =
      props.router.params.action === 'editar' ||
      props.router.params.action === 'rascunho' ||
      props.router.params.action === 'proposta'
        ? 'update'
        : 'create';
    const id_action = props.router.params.id;

    if (values.newPrice === 0 || values.newPrice === '0') {
      values.allowance = 0;
    }

    let publish = null;
    if (props.router.params.action === 'rascunho') {
      publish = () => {
        return props.publishAction(
          props.router.params.id,
          props.router,
          'subscribeProductForm',
          'SUBSCRIBE_PRODUCT_BUTTON_LOAD'
        );
      };
    }
    props.submitAction(values, props.router, create_or_update, id_action, publish);
  };

  function renderNoAccountScreen() {
    return (
      <section id="statement-buy-points" style={{ height: '100vh' }}>
        <MaterialGrid container spacing={3} alignItems="center">
          <MaterialGrid item xs={12} md={6}>
            <MaterialGrid container spacing={3}>
              <MaterialGrid item xs={12}>
                <h2 className="signup-text">
                  Você ainda não possui uma conta bancária cadastrada para poder vender produtos
                </h2>
                <PrimaryButton onClick={() => props.router.push('/owner/profile')}>
                  Cadastre agora
                </PrimaryButton>
              </MaterialGrid>
            </MaterialGrid>
          </MaterialGrid>
          <MaterialGrid item xs={12} md={6}>
            <img
              src={placeholder_illustration}
              className="img-fluid"
              alt="Ilustração: não há dados"
            />
          </MaterialGrid>
        </MaterialGrid>
      </section>
    );
  }

  function onDialogClose() {
    props.dispatchFormReset();
    const from = props.location.query.from ? props.location.query.from : 'online';
    props.router.push(
      props.router.params.action === 'editar'
        ? `/owner/acoes/minhas-atividades?from=${from}`
        : props.router.params.action === 'rascunho'
        ? '/owner/acoes/minhas-atividades?from=drafts'
        : props.router.params.action === 'proposta'
        ? '/owner/acoes/propostas'
        : '/owner'
    );
  }

  if (!props.auth.user.establishments[0].digital_account) {
    return renderNoAccountScreen();
  }

  console.log(props.subscribeProduct.status);

  return (
    <AlertDialogSlide
      label={'Venda de produtos físicos'}
      value={value}
      test={true}
      visible={true}
      height="95vh"
      form={form}
      onClose={handleOpenConfirmation}
      maxWidth={isMobile ? 'xl' : 'sm'}>
      {props.subscribeProduct.status === 'pending' || props.subscribeProduct.status === 'idle' ? (
        <div className="d-flex justify-content-center mt-5">
          <LoadingProgress />
        </div>
      ) : (
        <MaterialGrid
          container
          direction="column"
          justify="center"
          alignItems="stretch"
          sm={12}
          md={12}
          lg={12}>
          <ActionsTabs
            icons={[0, 0, 0, 0]}
            sectionTitles={[0, 0, 0, 0]}
            styles={{ marginBottom: 35, width: '100%' }}
            handleChange={handleNativeChange}
            onClickProgress={(values) => {
              if (values.submitFromButton) {
                return;
              }
              handleChange(values, props.router);
            }}
            goBack={goBack}
            activeTab={value}
            form="subscribeProductForm"
            tabs={[
              {
                content: (
                  <Informations
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    template={props.location.query.template}
                    type={props.location.query.type}
                    form="subscribeProductForm"
                    router={props.router}
                    onClickProgress={(values) => handleChange(values, props.router)}
                    disabled={props.router.params.action === 'editar'}
                  />
                ),
                icon: 'subject',
                label: 'Informações',
              },
              {
                content: (
                  <Interaction
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    onClickProgress={(values) => handleChange(values, props.router)}
                    prevClick={goBack}
                    router={props.router}
                  />
                ),
                icon: 'forum',
                label: 'Interações',
              },
              {
                content: (
                  <Prize
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    onClickProgress={(values) => handleChange(values, props.router)}
                    prevClick={goBack}
                    form="subscribeProductForm"
                    router={props.router}
                    disabled={props.router.params.action === 'editar'}
                  />
                ),
                label: 'Recompensas',
                icon: 'loyalty',
              },
              {
                content: (
                  <Publish
                    podeSerExclusivaDaJornada={false}
                    confirmationTitle={
                      props.router.params.action === 'editar'
                        ? 'Deseja sair da edição?'
                        : 'Deseja sair da edição?'
                    }
                    confirmationSubtitle={
                      props.router.params.action === 'editar'
                        ? 'Lembre-se, as informações que não foram salvas serão perdidas.'
                        : 'Lembre-se, as informações que não foram salvas serão perdidas.'
                    }
                    buttonConfirmationLabel={
                      props.router.params.action === 'editar'
                        ? 'Sim, sair da edição'
                        : 'Sim, sair da edição'
                    }
                    handleOpenConfirmation={handleOpenConfirmation}
                    handleCancelClose={handleCancelClose}
                    openConfirmation={openConfirmation}
                    setOpenConfirmation={setOpenConfirmation}
                    closeModal={onDialogClose}
                    onClickProgress={(values) => onSubmit(values)}
                    prevClick={goBack}
                    form="subscribeProductForm"
                    disabled={props.router.params.action === 'editar'}
                    router={props.router}
                  />
                ),
                label: 'Publicação',
                icon: 'settings',
              },
            ]}></ActionsTabs>
        </MaterialGrid>
      )}
    </AlertDialogSlide>
  );
}

Main.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
    }),
  }),
  subscribeProduct: PropTypes.shape({
    status: PropTypes.string,
  }),
  dispatchFormReset: PropTypes.func,
  formValues: PropTypes.any,
  getDetail: PropTypes.func,
  getLottiesList: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.shape({
      from: PropTypes.any,
      template: PropTypes.any,
      type: PropTypes.any,
    }),
  }),
  publishAction: PropTypes.func,
  router: PropTypes.shape({
    params: PropTypes.shape({
      action: PropTypes.string,
      id: PropTypes.any,
    }),
    push: PropTypes.func,
  }),
  savePartialy: PropTypes.func,
  submitAction: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    contacts: state.contacts,
    subscribeProduct: state.subscribeProduct,
    formValues: getFormValues('subscribeProductForm')(state),
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      submitAction,
      getDetail,
      dispatchFormReset,
      getLottiesList,
      savePartialy,
      publishAction,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
